import src from "IMAGE";
export default { src, width: 157, height: 122, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
